import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, Tag } from '@hub-la/design-system';

const RemainingPermissions = ({
  data: _data = [],
  children
}) => {
  const length = _data.length - 4;
  const remainingPermissionsAmount = `+ ${length - 1}`;
  return jsxs(Stack, Object.assign({
    direction: "row",
    gap: 2
  }, {
    children: [children, length > 1 && jsx(Tag, {
      size: "small",
      label: remainingPermissionsAmount,
      variant: "neutral"
    })]
  }));
};

export { RemainingPermissions };
